export const HOSTFULLY_ACCOUNTING_PATH = '/hostfully-accounting';
